export default {
  SignOut: 'Sign out',
  Tree: {
    Dashboard: {
      Title: 'Dashboard',
      Options: {
        YourDashboard: 'Your dashboard',
      },
    },
    Users: {
      Title: 'Users',
      Options: {
        New: 'Create new user',
        List: 'Users',
      },
    },
    Caregiver: {
      Title: 'Caregiver',
      Options: {
        New: 'Create new caregiver',
        List: 'Caregivers',
      },
    },
    ClientLead: {
      Title: 'Client lead',
      Options: {
        New: 'Create new client lead',
        List: 'Leads',
      },
    },
    Client: {
      Title: 'Client',
      Options: {
        New: 'Create new client',
        List: 'Clients',
      },
    },
    Schedule: {
      Title: 'Schedule',
      Options: {
        Client: 'View client schedule',
        Caregiver: 'View caregiver schedule',
      },
    },
    Career: {
      Title: 'Career',
      Options: {
        New: 'Create new job',
        List: 'Job listings',
      },
    },
  },
};
